export const getLostDamagedList = state => {
    return state.list
}

export const getLostDamagedDataProps = state => {
    return state.props
}

export const getLostDamagedRequestList = state => {
    return state.request_list
}


// WEBPACK FOOTER //
// ./src/store/modules/lostDamaged/getters.js